import axiosInstance from "./axiosInstance";

export const getData = async (method, properties, sorter) => {
  let uri = `/${method}`;
  if (properties) uri += `/${properties}`;

  try {
    const response = await axiosInstance.get(uri);
    if (response.status === 200) {
      return sorter ? response.data.sort(sorter) : response.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const postData = async (method, body) => {
  try {
    const response = await axiosInstance.post(`/${method}`, body);
    return response.status;
  } catch (error) {
    console.error("Error posting data:", error);
    return [];
  }
};

export const putData = async (method, body) => {
  try {
    const response = await axiosInstance.put(`/${method}`, body);
    return response.status;
  } catch (error) {
    console.error("Error updating data:", error);
    return [];
  }
};
